import { jsx as _jsx } from "react/jsx-runtime";
import App from './App';
import { ConfigProvider, ThemeProvider, ToastProvider } from './hoc';
export var DataEncryptionApp = function (_a) {
    var config = _a.config, _b = _a.isPreview, isPreview = _b === void 0 ? false : _b, theme = _a.theme, children = _a.children;
    return (_jsx(ThemeProvider, { theme: theme, children: _jsx(ConfigProvider, { config: config, children: _jsx(ToastProvider, { children: _jsx(App, { isPreview: isPreview, children: children }) }) }) }));
};
